export default __webpack_public_path__ + "static/media/c.7b4deb17.png";